import React from 'react'

import classNames from 'classnames'
import ReactDOM from 'react-dom'

import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'
import { ModalProps } from './types'
import { IconStyles } from '../Icon/styles'
import { Icon } from '../index'

export const Modal = ({
  children,
  className,
  isFullScreen,
  isOpen,
  onClose,
  title,
  mobileOnly = false,
  headerClassName,
  showBottomCloseButton = true,
}: ModalProps) => {
  const { t } = useTranslation()
  if (!isOpen) return null

  const root = document.getElementById('modal-root')

  const handleOverlayClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const modalOverlayStyles = classNames(styles.modalOverlay, {
    [styles.mobileOnly]: mobileOnly,
  })

  const contentStyles = classNames(styles.modalContent, className, {
    [styles.fullScreen]: isFullScreen,
  })

  return ReactDOM.createPortal(
    <div className={modalOverlayStyles} onClick={handleOverlayClick}>
      <div className={contentStyles}>
        <div className={classNames(styles.modalHeader, headerClassName)}>
          <h2>{title}</h2>
          <button className={styles.closeButtonTopRight} onClick={onClose}>
            <Icon path="icons/icon-close" style={IconStyles.small} />
          </button>

          <button
            className={styles.closeButtonTopRightMobile}
            onClick={onClose}
          >
            {t('Chat.Message.Close')}
          </button>
        </div>
        <div className={styles.modalMain}>{children}</div>
        {showBottomCloseButton && (
          <button className={styles.closeButtonBottomRight} onClick={onClose}>
            {t('Chat.Message.Close')}
          </button>
        )}
      </div>
    </div>,
    root || document.body
  )
}
